import { useState, useEffect } from "react";
import { G, ADMIN_API, IcoLogs } from "../../design/tokens";
import StatCard from "./StatCard";

export default function LogsModule({ authHeader }) {
  const [logs, setLogs]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter]   = useState("all");

  useEffect(() => {
    fetch(`${ADMIN_API}/logs`, { headers: authHeader })
      .then(r => r.json())
      .then(d => { setLogs(d.logs || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const success  = logs.filter(l => l.success).length;
  const failed   = logs.filter(l => !l.success).length;
  const filtered = logs.filter(l => filter === "all" || (filter === "success" ? l.success : !l.success));

  const TH = { fontFamily: "'Space Grotesk', sans-serif", fontSize: 10, color: "rgba(255,255,255,0.3)", letterSpacing: 2, textTransform: "uppercase", padding: "12px 20px", textAlign: "left", borderBottom: "1px solid rgba(255,255,255,0.04)", fontWeight: 500 };

  return (
    <div style={{ padding: "28px 32px" }}>
      <div style={{ display: "flex", gap: 16, marginBottom: 28 }}>
        <StatCard icon={<IcoLogs />} label="Total Events" value={logs.length} accent="#2563EB" />
        <StatCard icon={<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>} label="Successful Logins" value={success} accent="#059669" />
        <StatCard icon={<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>} label="Failed Attempts" value={failed} accent="#DC2626" />
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
        <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, fontWeight: 600, color: "#fff" }}>Login Logs</div>
        <div style={{ display: "flex", gap: 6 }}>
          {["all","success","fail"].map(f => (
            <button key={f} onClick={() => setFilter(f)} style={{ padding: "7px 16px", borderRadius: 8, border: `1px solid ${filter === f ? "rgba(37,99,235,0.45)" : "rgba(255,255,255,0.06)"}`, background: filter === f ? "rgba(37,99,235,0.13)" : "transparent", color: filter === f ? "#93C5FD" : "rgba(255,255,255,0.35)", fontFamily: "'Space Grotesk', sans-serif", fontSize: 12, cursor: "pointer", textTransform: "capitalize", transition: "all 0.15s" }}>{f}</button>
          ))}
        </div>
      </div>

      {loading ? (
        <div style={{ fontFamily: "'Space Grotesk', sans-serif", color: "rgba(255,255,255,0.25)", fontSize: 14, padding: "60px 0", textAlign: "center" }}>Loading…</div>
      ) : (
        <div style={{ background: G.glass, border: `1px solid ${G.glassBrd}`, borderRadius: 16, overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "rgba(4,10,24,0.6)" }}>
                {["Username","Status","IP Address","User Agent","Date & Time"].map(h => <th key={h} style={TH}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={5} style={{ fontFamily: "'Space Grotesk', sans-serif", color: "rgba(255,255,255,0.2)", fontSize: 13, padding: "48px", textAlign: "center" }}>No logs found</td></tr>
              ) : filtered.map((l, i) => (
                <tr key={l.logId || i} style={{ borderBottom: "1px solid rgba(255,255,255,0.03)", transition: "background 0.15s" }}
                  onMouseEnter={e => e.currentTarget.style.background = "rgba(37,99,235,0.05)"}
                  onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                >
                  <td style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 13, color: "#fff", padding: "14px 20px", fontWeight: 500 }}>{l.username}</td>
                  <td style={{ padding: "14px 20px" }}>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "4px 12px", borderRadius: 6, fontSize: 11, fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600, background: l.success ? "rgba(5,150,105,0.12)" : "rgba(220,38,38,0.12)", color: l.success ? "#34D399" : "#f87171", border: `1px solid ${l.success ? "rgba(52,211,153,0.2)" : "rgba(248,113,113,0.2)"}` }}>
                      <span style={{ width: 5, height: 5, borderRadius: "50%", background: "currentColor", display: "inline-block" }} />
                      {l.success ? "Success" : "Failed"}
                    </span>
                  </td>
                  <td style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 12, color: "rgba(255,255,255,0.35)", padding: "14px 20px" }}>{l.ip || "—"}</td>
                  <td style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 11, color: "rgba(255,255,255,0.25)", padding: "14px 20px", maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{l.userAgent || "—"}</td>
                  <td style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 12, color: "rgba(255,255,255,0.3)", padding: "14px 20px" }}>{l.createdAt ? new Date(l.createdAt).toLocaleString() : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
